import { DOCS_FORM_NAMES } from "core/consts";
import { getFormGetters } from "dsl/ecosystems/PatientForms/TransitionalCare/Form/Import";
import { FormFieldConfigFactory } from "..";
import { TransitionalCareFormSections } from "./sections";
import { getTransitionalCareFormSchema } from "./schema";

export const getTransitionalCareFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.TRANSITIONAL_CARE
> = ({ translations }) => {
  return {
    auctionToForm: getFormGetters,
    config: { canPrint: true, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        aftercare_application_date:
          value?.aftercare_application_date ?? undefined,
        aftercare_application_explanation:
          value?.aftercare_application_explanation ?? "",
        aftercare_application_submitted:
          value?.aftercare_application_submitted ?? undefined,
        aftercare_care_level_aftercare_required:
          value?.aftercare_care_level_aftercare_required ?? undefined,
        aftercare_care_level_applied:
          value?.aftercare_care_level_applied ?? undefined,
        aftercare_care_level_applied_date:
          value?.aftercare_care_level_applied_date ?? undefined,
        aftercare_care_level_available:
          value?.aftercare_care_level_available ?? undefined,
        aftercare_care_level_explanation:
          value?.aftercare_care_level_explanation ?? "",
        aftercare_medical_rehab: value?.aftercare_medical_rehab ?? undefined,
        aftercare_mobile: value?.aftercare_mobile ?? undefined,
        aftercare_shortterm_care: value?.aftercare_shortterm_care ?? undefined,
        aftercare_start_date: value?.aftercare_start_date ?? undefined,
        care_necessity: value?.care_necessity ?? undefined,
        clinic_ik_number: value?.clinic_ik_number ?? "",
        clinic_location_city: value?.clinic_location_city ?? "",
        clinic_location_street: value?.clinic_location_street ?? "",
        clinic_location_street_number:
          value?.clinic_location_street_number ?? "",
        clinic_location_zipcode: value?.clinic_location_zipcode ?? "",
        clinic_name: value?.clinic_name ?? "",
        handover_to_insurance_date:
          value?.handover_to_insurance_date ?? undefined,
        insurance_form_sent_date: value?.insurance_form_sent_date ?? undefined,
        internet_portal_used: value?.internet_portal_used ?? undefined,
        legal_representative_consent_provided:
          value?.legal_representative_consent_provided ?? undefined,
        legal_representative_first_name:
          value?.legal_representative_first_name ?? "",
        legal_representative_last_name:
          value?.legal_representative_last_name ?? "",
        legal_representative_location_city:
          value?.legal_representative_location_city ?? "",
        legal_representative_location_street:
          value?.legal_representative_location_street ?? "",
        legal_representative_location_street_number:
          value?.legal_representative_location_street_number ?? "",
        legal_representative_location_zipcode:
          value?.legal_representative_location_zipcode ?? "",
        patient_date_of_birth: value?.patient_date_of_birth ?? undefined,
        patient_first_name: value?.patient_first_name ?? "",
        patient_insurance_number: value?.patient_insurance_number ?? "",
        patient_last_name: value?.patient_last_name ?? "",
        patient_location_city: value?.patient_location_city ?? "",
        patient_location_house_number:
          value?.patient_location_house_number ?? "",
        patient_location_street: value?.patient_location_street ?? "",
        patient_location_zipcode: value?.patient_location_zipcode ?? "",
        prior_treatment_end_date: value?.prior_treatment_end_date ?? undefined,
        prior_treatment_hospital_id: value?.prior_treatment_hospital_id ?? "",
        prior_treatment_start_date:
          value?.prior_treatment_start_date ?? undefined,
        request_list: value?.request_list ?? [],
        social_worker_email: value?.social_worker_email ?? "",
        social_worker_fax: value?.social_worker_fax ?? "",
        social_worker_first_name: value?.social_worker_first_name ?? "",
        social_worker_last_name: value?.social_worker_last_name ?? "",
        social_worker_telephone: value?.social_worker_telephone ?? "",
        transitional_care_department_code:
          value?.transitional_care_department_code ?? "",
        transitional_care_description:
          value?.transitional_care_description ?? "",
        transitional_care_end_date:
          value?.transitional_care_end_date ?? undefined,
        transitional_care_location_id:
          value?.transitional_care_location_id ?? "",
        transitional_care_patient_confirmation:
          value?.transitional_care_patient_confirmation ?? undefined,
        transitional_care_patient_confirmation_date:
          value?.transitional_care_patient_confirmation_date ?? undefined,
        transitional_care_patient_confirmation_explanation:
          value?.transitional_care_patient_confirmation_explanation ?? "",
        transitional_care_start_date:
          value?.transitional_care_start_date ?? undefined,
        transitional_care_start_search_date:
          value?.transitional_care_start_search_date ?? undefined,
        transitional_care_suitable_providers_count:
          value?.transitional_care_suitable_providers_count ?? undefined,
        transitional_care_suitable_providers_more_than_twenty:
          value?.transitional_care_suitable_providers_more_than_twenty ??
          undefined,
      };
    },
    header: ({ translations }) =>
      translations.patientForms.transitionalCareForm.title,
    schema: getTransitionalCareFormSchema(translations),
    sections: TransitionalCareFormSections,
  };
};
